export default {
  customerService: '18004743794',
  customerServiceFormatted: '1-800-474-3794',
  customerServicePretty: '1-800-4Sherwin'
}
